import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LocaleService } from './locale.service';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common/http";
import * as i3 from "./locale.service";
import * as i4 from "./auth.service";
export class TrackingService {
    constructor(router, http, localeService, auth) {
        this.router = router;
        this.http = http;
        this.localeService = localeService;
        this.auth = auth;
    }
    trackPageViews() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            this.sendEvent('page_view', event.urlAfterRedirects, {});
        });
    }
    trackCustomEvent(eventName, data = {}) {
        let url = this.router.url;
        this.sendEvent(eventName, url, data);
    }
    sendEvent(eventType, url, data) {
        const serviceUrl = `${environment.apiUrl}/${environment.apiVersion}/activity/store?l=${this.localeService.getLocale()}`;
        const payload = {
            '_event': eventType,
            '_api_key': environment.apiKey,
            '_user': this.auth.getUser() ? this.auth.getUser().username : null,
            '_route': url,
            '_data': data
        };
        this.http.post(serviceUrl, payload)
            .subscribe({
            next: () => console.log(`Event ${eventType} sent successfully`),
            error: (err) => console.error(`Error sending event: ${err}`)
        });
    }
}
TrackingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TrackingService_Factory() { return new TrackingService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LocaleService), i0.ɵɵinject(i4.AuthService)); }, token: TrackingService, providedIn: "root" });
